/* global axios */
import ApiClient from './ApiClient';

class OrbixMonitor extends ApiClient {
  constructor() {
    super('orbix_monitor', { accountScoped: true });
  }

  getToken() {
    return axios.get(`${this.url}/token`);
  }
}

export default new OrbixMonitor();
